import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api, { formatEuro, formatDateTime } from "@/lib/api";
import { Badge } from "@/components/ui/badge";
import { Input } from "@/components/ui/input";
import { Search } from "lucide-react";

const STATUS = {
  priced: { label: "Devis généré", cls: "bg-[#EAF1F7] text-[#16324F]" },
  booked: { label: "Réservé", cls: "bg-[#19C3B3]/15 text-[#0F7A70]" },
  to_review: { label: "À étudier", cls: "bg-[#FF7A59]/15 text-[#B84324]" },
  cancelled: { label: "Annulé", cls: "bg-slate-100 text-slate-500" },
  completed: { label: "Terminé", cls: "bg-emerald-100 text-emerald-700" },
};

export default function Requests() {
  const [items, setItems] = useState([]);
  const [q, setQ] = useState("");

  useEffect(() => { api.get("/quotes").then((r) => setItems(r.data)); }, []);

  const filtered = items.filter((it) => {
    const s = q.toLowerCase();
    if (!s) return true;
    return (
      it.vehicle?.brand?.toLowerCase().includes(s) ||
      it.vehicle?.model?.toLowerCase().includes(s) ||
      it.service_name?.toLowerCase().includes(s) ||
      it.customer?.name?.toLowerCase().includes(s) ||
      it.location?.city?.toLowerCase().includes(s)
    );
  });

  return (
    <div>
      <h1 className="font-display text-3xl font-extrabold text-[#16324F]">Demandes</h1>
      <p className="mt-1 text-slate-500">Toutes les demandes de devis reçues via MonTempsGagné.</p>

      <div className="mt-6 flex items-center gap-3">
        <div className="relative flex-1 max-w-md">
          <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-slate-400"/>
          <Input placeholder="Rechercher un client, un véhicule…" className="pl-9 h-11 rounded-full bg-white" value={q} onChange={(e) => setQ(e.target.value)} data-testid="requests-search"/>
        </div>
        <div className="text-sm text-slate-500">{filtered.length} demandes</div>
      </div>

      <div className="mt-6 kf-card overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 border-b border-slate-100 text-slate-500">
            <tr>
              <th className="text-left px-4 py-3 font-semibold">Date</th>
              <th className="text-left px-4 py-3 font-semibold">Client</th>
              <th className="text-left px-4 py-3 font-semibold">Véhicule</th>
              <th className="text-left px-4 py-3 font-semibold">Prestation</th>
              <th className="text-left px-4 py-3 font-semibold">Lieu</th>
              <th className="text-right px-4 py-3 font-semibold">Montant</th>
              <th className="text-left px-4 py-3 font-semibold">Statut</th>
            </tr>
          </thead>
          <tbody>
            {filtered.map((it) => (
              <tr key={it.id} className="border-b border-slate-50 hover:bg-slate-50/70 cursor-pointer" onClick={() => window.location.assign(`/app/demandes/${it.id}`)} data-testid={`request-row-${it.id}`}>
                <td className="px-4 py-3 text-slate-600">{formatDateTime(it.created_at)}</td>
                <td className="px-4 py-3 font-semibold text-[#16324F]">{it.customer?.name || <span className="text-slate-400 italic">—</span>}</td>
                <td className="px-4 py-3">{it.vehicle?.brand} {it.vehicle?.model} <span className="text-slate-400">· {it.vehicle?.year}</span></td>
                <td className="px-4 py-3 text-slate-700">{it.service_name}</td>
                <td className="px-4 py-3 text-slate-600">{it.location?.city} <span className="text-slate-400 text-xs">{it.location?.postal_code}</span></td>
                <td className="px-4 py-3 text-right font-semibold text-[#16324F]">{it.price ? formatEuro(it.price) : "—"}</td>
                <td className="px-4 py-3"><Badge className={`${STATUS[it.status]?.cls} border-0 font-semibold`}>{STATUS[it.status]?.label}</Badge></td>
              </tr>
            ))}
            {filtered.length === 0 && (
              <tr><td colSpan={7} className="text-center py-16 text-slate-400">Aucune demande.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
